import React, { Component } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { translate } from '../../Services/translation';
import { add as addToCartService, restart } from '../Services/Cart.service';

const NoNameCustomProductModal = () => {
    const displayNoNameCustomProductModal = useSelector((state) => state.displayNoNameCustomProductModal);
    let myRef = React.createRef();

    const onClick = async () => {
        const articleNumber = displayNoNameCustomProductModal.payload.articleNumber;
        const quantityFieldId = displayNoNameCustomProductModal.payload.quantityFieldId;
        const articleType = displayNoNameCustomProductModal.payload.articleType
        const productName = document.querySelector('#custom-product-name-input').value;

        if (productName !== "" && productName.length > 0 && productName.length <= 50) {
            const quantity = quantityFieldId
                ? document.getElementById(quantityFieldId)?.value ?? 1
                : 1;
            await addToCartService({ articleNumber, quantity, articleType, productName });
            window.location.reload();
        } else {
            myRef.current.querySelector('.input-validation-text').classList.add('error');
        }
    };
    const onClickRestart = async () => {
        await restart();
        window.location.href = window.location.href.split('?')[0];
    };

    const onKeyDown = async () => {
        myRef.current.querySelector('.input-validation-text').classList.remove('error');
    };

    if (displayNoNameCustomProductModal && displayNoNameCustomProductModal.payload && displayNoNameCustomProductModal.payload.displayNoNameCustomProductModal) {
        return (
            <div ref={myRef} className="lightbox">
                <div className="lightbox-content">
                    <div className="lightbox-content-scroll">
                        <div className="custom-product-modal">
                            <p className="custom-product-modal__subtitle" dangerouslySetInnerHTML={{
                                __html: displayNoNameCustomProductModal.payload.infoText?.value
                            }}></p>

                            <div className="input-wrapper">
                                <label><span>{translate("code.product.page.noname.customproduct")}</span></label>
                                <input id="custom-product-name-input" type="text" onKeyDown={() => onKeyDown()} />
                            </div>
                            <label htmlFor="custom-product-name-input" className="input-validation-text">{displayNoNameCustomProductModal.payload.inputValidationText}</label>
                            <div className="actions">
                                <a className="btn btn--grey btn--rounded" onClick={() => onClickRestart()}>{translate("code.product.page.start.over")}</a>
                                <a className="btn btn--yellow btn--rounded" onClick={() => onClick()}>
                                    {translate("code.product.page.save")}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    } else {
        return (<div></div>);
    }

}

export default NoNameCustomProductModal;